import React from "react";
import "./NotFound.scss";
import EAElevatedContainer from "../shared/EAElevatedContainer";
import EADivider from "../shared/EADivider";

const NotFoundPage: React.FC = () => {
  return (
    <div className="notfoundpage-container">
      <EAElevatedContainer>
        <div className="notfoundpage-content-wrapper">
          <span className="display1 text-centered text-color-dark-gray">404</span>
          <h1 className="text-centered text-color-dark-gray">
            Strona, której szukasz, zniknęła <br /> w czarnej dziurze internetu.
          </h1>
          <span className="body-large text-centered text-color-dark-gray">
            Przepraszamy, ale strona, której szukasz, nie została znaleziona. <br />
            Możliwe przyczyny:
            <ul>
              <li>Adres URL został wpisany nieprawidłowo</li>
              <li>Strona została usunięta lub przeniesiona</li>
              <li>Tymczasowe problemy techniczne</li>
            </ul>
          </span>
          <EADivider />
          <p className="text-centered">
            Jeśli problem się powtarza, zgłoś to na{" "}
            <a
              href="mailto:pomoc@eaktywni.pl?subject=Zg%C5%82oszenie%20b%C5%82%C4%99du%20%28strona%20404%29"
              className="button-text text-color-dark"
            >
              pomoc@eaktywni.pl
            </a>
          </p>
        </div>
      </EAElevatedContainer>
    </div>
  );
};

export default NotFoundPage;
